'use client'

import { QueryClient, QueryClientConfig, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      // refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24,
    },
  },
}
export default function RQProviders({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(() => new QueryClient(queryClientConfig))

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      {children}
    </QueryClientProvider>
  )
}
